// extracted by mini-css-extract-plugin
export default {"labels":"labelWithHR_labels__s9aFV","hr":"labelWithHR_hr__0TR-T"};